import $ from 'jquery';
import 'slick-carousel';

$('.impressions').each(function () {
    const $parent = $(this);
    const $mainSlider = $parent.find('.impressions__main-slider__slider');
    const $navSlider = $parent.find('.impressions__nav-slider__slider');

    $mainSlider.slick({
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: false,
        rows: 0,
        prevArrow: '<button title="'+ window.translationStrings.prevSlide +'" class="slick-prev fa-thin fa-arrow-left"></button>',
        nextArrow: '<button title="'+ window.translationStrings.nextSlide +'" class="slick-next fa-thin fa-arrow-right"></button>',
        appendArrows: $('<div>', {class: 'impressions__arrows'}).insertAfter($mainSlider),
        asNavFor: $navSlider,
        adaptiveHeight: true,
    });

    $navSlider.slick({
        autoplay: false,
        infinite: true,
        arrows: false,
        dots: false,
        draggable: true,
        rows: 0,
        vertical: true,
        verticalSwipe: true,
        swipeToSlide: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: $mainSlider,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    vertical: false,
                    verticalSwipe: false,
                }
            }
        ]
    });
});
